// AddGuardianPage.jsx
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
  SimpleGrid,
  Heading,
  Flex,
  Text,
  VStack,
  Grid,
  Icon,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";
import { FaList, FaUser } from "react-icons/fa";

const AddGuardian = () => {
  const [nations, setNations] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [guardianFormData, setGuardianFormData] = useState({
    name: "",
    address: "",
    email: "",
    contact_no: "",
    nation: "",
    state: "",
    relation: "",
    district: "",
    place: "",
    username: "",
    password: "",
    confirm_password: "",
  });

  const toast = useToast();
  const navigate = useNavigate();

  // fetch nations
  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/staff/nation_master.php`)
      .then((res) => setNations(res.data.data || []))
      .catch((err) => console.error("Error fetching nations:", err));
  }, []);

  // fetch states
  useEffect(() => {
    if (guardianFormData.nation) {
      axios
        .get(`${BASE_URL}/admin/staff/state_master.php`)
        .then((res) => {
          const filtered = res.data.data.filter(
            (s) => s.nation_id === guardianFormData.nation
          );
          setStates(filtered);
        })
        .catch((err) => console.error("Error fetching states:", err));
    } else {
      setStates([]);
      setDistricts([]);
    }
  }, [guardianFormData.nation]);

  // fetch districts
  useEffect(() => {
    if (guardianFormData.state) {
      axios
        .post(
          `${BASE_URL}/admin/staff/district_master.php`,
          { state_id: guardianFormData.state },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((res) => setDistricts(res.data.data || []))
        .catch((err) => console.error("Error fetching districts:", err));
    } else {
      setDistricts([]);
    }
  }, [guardianFormData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGuardianFormData((prev) => ({ ...prev, [name]: value }));
  };
  const validateEmail = (email) => {
    if (!email) return true; // no email entered → skip validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async () => {
    const { email } = guardianFormData;

    if (!validateEmail(email)) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/admin/guardian/create_guardian.php`,
        {
          ...guardianFormData,
          school_id: sessionStorage.getItem("school_id"),
          pass: sessionStorage.getItem("user_id"),
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success === false) {
        toast({
          title: "Error",
          description: res.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Success",
          description: res.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        // after save go back to student form
        navigate(-1); // go back to previous page
      }
    } catch (err) {
      toast({
        title: "Error",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const handleClick = () => {
    navigate("/guardian/list"); // Navigate to the desired route
  };

  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div
            className="header"
            style={{ display: "flex", alignItems: "center" }}
          >
            <h1 style={{ fontSize: "20px", margin: 0 }}>Add Guardian</h1>
            <div className="action-buttons" style={{ marginLeft: "auto" }}>
              <Button
                className="add-teacher-button"
                onClick={handleClick}
                leftIcon={<FaList />}
                colorScheme="teal" // Optional: You can customize the color scheme
              >
                <Box display={{ base: "none", md: "block" }}>Guardian</Box>
              </Button>
            </div>
          </div>

          <Box className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Students</span> / <span>Add Guardian</span>
          </Box>
        </div>
        <VStack spacing={4} align="stretch" p={7}>
          <Box width="100%" bg="#F2F5FF" p={1} borderRadius="md">
            <Flex align="center" mb={4} mt={2} ml={2}>
              <Icon as={FaUser} boxSize={6} color="teal" mr={2} />
              <Text fontSize="lg" fontWeight="bold">
                Guardian Information
              </Text>
            </Flex>
          </Box>
          <Grid
            // columns={2}
            // spacing={6}
            templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
            gap={6}
            mb={6}
            p={3}
          >
            {" "}
            <FormControl id="name" isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                name="name"
                value={guardianFormData.name}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="address" isRequired>
              <FormLabel>Address</FormLabel>
              <Input
                name="address"
                value={guardianFormData.address}
                onChange={handleChange}
              />
            </FormControl>
            {/* <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="email"
                value={guardianFormData.email}
                onChange={handleChange}
              />
            </FormControl> */}
            <FormControl
              id="email"
              isInvalid={
                guardianFormData.email !== "" &&
                !validateEmail(guardianFormData.email)
              }
            >
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="email"
                value={guardianFormData.email}
                onChange={handleChange}
              />
              {/* {guardianFormData.email !== "" &&
                !validateEmail(guardianFormData.email) && (
                  <FormErrorMessage>Enter a valid email</FormErrorMessage>
                )} */}
            </FormControl>
            <FormControl id="relation" isRequired>
              <FormLabel>Relation</FormLabel>
              <Input
                name="relation"
                value={guardianFormData.relation}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="contact_no" isRequired>
              <FormLabel>Contact No</FormLabel>
              <Input
                name="contact_no"
                value={guardianFormData.contact_no}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="nation" isRequired>
              <FormLabel>Nation</FormLabel>
              <Select
                name="nation"
                value={guardianFormData.nation}
                onChange={handleChange}
              >
                <option value="">Select Nation</option>
                {nations.map((nation) => (
                  <option key={nation.id} value={nation.id}>
                    {nation.nation}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl id="state" isRequired>
              <FormLabel>State</FormLabel>
              <Select
                name="state"
                value={guardianFormData.state}
                onChange={handleChange}
                disabled={!guardianFormData.nation}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.state}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl id="district" isRequired>
              <FormLabel>District</FormLabel>
              <Select
                name="district"
                value={guardianFormData.district}
                onChange={handleChange}
                disabled={!guardianFormData.state}
              >
                <option value="">Select District</option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.district}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl id="place" isRequired>
              <FormLabel>Place</FormLabel>
              <Input
                name="place"
                value={guardianFormData.place}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="username" isRequired>
              <FormLabel>Username</FormLabel>
              <Input
                name="username"
                value={guardianFormData.username}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                name="password"
                value={guardianFormData.password}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="confirm_password" isRequired>
              <FormLabel>Confirm Password</FormLabel>
              <Input
                type="password"
                name="confirm_password"
                value={guardianFormData.confirm_password}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
          <Flex justify="center">
            <Button colorScheme="teal" px={10} onClick={handleSubmit}>
              Save
            </Button>
          </Flex>
        </VStack>
      </div>
    </Box>
  );
};

export default AddGuardian;
